// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-alert .weui-dialog{font-size:px2rem(32)}", "",{"version":3,"sources":["webpack://./resources/js/components/ui/Alert.vue"],"names":[],"mappings":"AAAA,uBAAuB,oBAAoB","sourcesContent":[".ui-alert .weui-dialog{font-size:px2rem(32)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
